import { CustomFieldType } from '@tribeplatform/gql-client/types'
import { noop } from '@tribeplatform/react-ui-kit/hooks'
import { type IconSize, SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

interface Props {
  type: CustomFieldType
  size?: IconSize
}
export const FieldTypeIcon = ({ type, size = 'md' }: Props) => {
  switch (type) {
    case CustomFieldType.array:
      return <SvgIcon name="rows" size={size} />
    case CustomFieldType.boolean:
      return <SvgIcon name="status-success" size={size} />
    case CustomFieldType.date:
      return <SvgIcon name="calendar" size={size} />
    case CustomFieldType.number:
      return <SvgIcon name="hash" size={size} />
    case CustomFieldType.object:
      return <SvgIcon name="code-box" size={size} />
    case CustomFieldType.relation:
      return <SvgIcon name="link-external" size={size} />
    case CustomFieldType.richText:
      return <SvgIcon name="post" size={size} />
    case CustomFieldType.text:
      return <SvgIcon name="bars-uneven-middle" size={size} />
    default: {
      // Code should never reach the default case
      const exhaustiveCheck: never = type
      noop(exhaustiveCheck)
      return null
    }
  }
}
